import React from "react";
import styled from "styled-components/macro";
import Dialog from "@fluentui/react/lib/Dialog";
import { ResourceStrings } from "../../ResourceStrings";
import { NotificationType } from "../../store/appState";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";

export interface NotificationDialogProps {
    notificationType: NotificationType;
    title?: string;
    message?: string;
    children?: JSX.Element;
    isOpen: boolean;
    canDismiss?: boolean;
    isCritical?: boolean;
    isBlocking?: boolean;
    showSpinner?: boolean;
    onDismiss?: () => void;
}

export default function NotificationDialog(props: NotificationDialogProps): JSX.Element {
    return <DialogWrapper
        hidden={!props.isOpen}
        onDismiss={() => {
            if (props.canDismiss && props.onDismiss) {
                props.onDismiss();
            }
        }}
        modalProps={{
            isBlocking: props.isBlocking,
            styles: {
                main: {
                    border: `solid 2px ${colorForNotification(props.notificationType)}`,
                    borderRadius: '.8rem',
                }
            }
        }}
        dialogContentProps={{
            showCloseButton: props.canDismiss,
            title: props.title,
            closeButtonAriaLabel: ResourceStrings.close(),
            subText: props.message,
            styles: {
                subText: {
                    textAlign: 'center',
                    marginTop: '2rem',
                    fontSize: '1.8rem'
                }
            }
        }}
    >
        <span
            id="notificationMessageReader"
            className="visually-hidden"
            role={props.isCritical ? "alert" : "status"}
            aria-live="assertive"
            aria-hidden={!props.isOpen}
        >{props.title ?? ''} {props.message}</span>

        {props.showSpinner && <Spinner size={SpinnerSize.large} />}

        {props.children}
    </DialogWrapper>
}

const colorForNotification = (notificationType: NotificationType): string => {
    switch (notificationType) {
        case "error":
            return "var(--color-error)";
        case "information":
            return "var(--color-info)";
        case "warning":
            return "var(--color-warning)";
        default:
            return "var(--color-on-surface)";
    }
}

const DialogWrapper = styled(Dialog)`
    .ms-Dialog-main {
        min-width: 20rem;
        max-width: 90rem;
        width: 80%;
    }
`;